<template>
    <div>
        <!-- Edit -->
        <div class="container" v-if="EditView">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">{{ Servico.lseId ? 'Alterar serviço extra' : 'Novo serviço extra' }}</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home">
                            <router-link to="/home"><i class="fa fa-home"></i></router-link>
                        </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i></li>
                        <li class="nav-item">
                            <a href="#" @click.prevent="EditCancel()">Cadastro de Serviço Extra</a>
                        </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i></li>
                        <li class="nav-item"><span>{{ Servico.lseId ? 'Alterar' : 'Novo cadastro' }}</span></li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="gp-admin-form-header">
                                <span><v-icon size="20">mdi-briefcase-plus-outline</v-icon></span>
                                <div>
                                    <h4>{{ Servico.lseId ? 'Alterar serviço extra' : 'Novo serviço extra' }}</h4>
                                    <p>Preencha os dados e defina a disponibilidade deste cadastro.</p>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-2 col-lg-2" v-show="false">
                                        <div class="form-group">
                                            <label>Identificador</label>
                                            <input v-model="Servico.lseId" type="text" class="form-control" placeholder="Id" readonly />
                                        </div>
                                    </div>

                                    <div class="col-md-6 col-lg-6">
                                        <div class="form-group">
                                            <label>Nome</label>
                                            <input v-model="Servico.lseNome" type="text" class="form-control" placeholder="Nome do serviço extra" />
                                        </div>
                                    </div>

                                    <div class="col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label>Quantidade</label>
                                            <input v-model.number="Servico.lseQuantidade" type="number" min="0" class="form-control" placeholder="Quantidade" />
                                        </div>
                                    </div>

                                    <div class="col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label>Valor</label>
                                            <input v-model.number="Servico.lseValor" type="number" step="0.01" min="0" class="form-control" placeholder="Valor" />
                                        </div>
                                    </div>

                                    <div class="col-md-6 col-lg-6">
                                        <div class="form-group">
                                            <label>Periodicidade</label>
                                            <select v-model="Servico.lsePeriodicidade" class="form-select form-control">
                                                <option value="">Selecione</option>
                                                <option value="Mensal">Mensal</option>
                                                <option value="Anual">Anual</option>
                                                <option value="Única">Única</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-md-6 col-lg-6">
                                        <div class="form-group">
                                            <label>Código Serviço GarantePay</label>
                                            <input v-model.number="Servico.lseCodigoServicoGarantePay" type="number" min="0" class="form-control" placeholder="Código do serviço GarantePay" />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-action gp-admin-actions gp-detail-actions">
                        <button v-if="Servico.lseId != 0" type="button" class="btn btn-success" style="color:#ffffff;" @click="Put()">
                            Alterar
                        </button>
                        <button v-else type="button" class="btn btn-success" style="color:#ffffff;" @click="Add()">
                            Salvar
                        </button>
                        <a href="#" @click="EditCancel()" class="btn btn-link">Cancelar</a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Grid -->
        <div class="container" v-if="!EditView">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Cadastro de Serviço Extra</h4>
                                    <a href="#" @click="EditNew()" class="btn btn-sm btn-secondary ms-auto">
                                        <i class="fa fa-plus"></i>
                                        Incluir Novo
                                    </a>
                                </div>
                            </div>
                            <div class="card-body">
                                <adm-data-table :headers="headers" :items="Servicos" v-model="itemsSelected" alternating
                                    theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                                    body-text-direction="center" rows-per-page-message="Linhas por pagina">
                                    <template #item-lseValor="item">
                                        <span>{{ formatCurrency(item.lseValor) }}</span>
                                    </template>
<template #item-actions="item">
    <div class="gp-table-actions">
        <button type="button" class="gp-table-action gp-action-edit" title="Editar" @click="EditGrid(item)"><v-icon size="17">mdi-pencil-outline</v-icon></button>
        <button v-show="false" type="button" class="gp-table-action gp-action-delete" title="Excluir" @click="DeleteGrid(item)"><v-icon size="17">mdi-trash-can-outline</v-icon></button>
    </div>
</template>
                                </adm-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
export default {
    name: 'CadastroListaServicosExtrasView',
    components: {
        EasyDataTable
    },
    data: () => ({
        EditView: false,
        Servico: {
            lseId: 0,
            lseNome: '',
            lseQuantidade: 0,
            lseValor: 0.0,
            lsePeriodicidade: '',
            lseCodigoServicoGarantePay: 0,
        },
        Servicos: [],
        headers: [
            { text: 'Id', value: 'lseId', sortable: true, width: 60 },
            { text: 'Nome', value: 'lseNome', sortable: true, width: 220 },
            { text: 'Quantidade', value: 'lseQuantidade', sortable: true, width: 120 },
            { text: 'Valor', value: 'lseValor', sortable: true, width: 120 },
            { text: 'Periodicidade', value: 'lsePeriodicidade', sortable: true, width: 160 },
            { text: 'Código Serviço', value: 'lseCodigoServicoGarantePay', sortable: true, width: 160 },
            { text: 'Ações', value: 'actions', width: 100 }
        ],
        itemsSelected: [],
        searchValue: '',
    }),
    methods: {
        EditNew() {
            this.EditView = true;
            this.Servico = {
                lseId: 0,
                lseNome: '',
                lseQuantidade: 0,
                lseValor: 0.0,
                lsePeriodicidade: '',
                lseCodigoServicoGarantePay: 0,
            };
        },
        EditGrid(item) {
            this.EditView = true;
            if (item && item.lseId) {
                axios.get(`/Telas/CadastroListaServicoExtra/GetById/${item.lseId}`)
                    .then(response => {
                        this.Servico = response.data;
                    });
            }
        },
        Add() {
            if (!this.Servico.lseNome) {
                this.$mensagemAviso('Nome Obrigatório.');
            } else if (this.Servico.lseQuantidade === null || this.Servico.lseQuantidade === undefined) {
                this.$mensagemAviso('Quantidade Obrigatória.');
            } else if (this.Servico.lseValor === null || this.Servico.lseValor === undefined) {
                this.$mensagemAviso('Valor Obrigatório.');
            } else if (!this.Servico.lsePeriodicidade) {
                this.$mensagemAviso('Periodicidade Obrigatória.');
            } else if (this.Servico.lseCodigoServicoGarantePay === null || this.Servico.lseCodigoServicoGarantePay === undefined) {
                this.$mensagemAviso('Código do Serviço GarantePay Obrigatório.');
            } else {
                axios.post(`/Telas/CadastroListaServicoExtra/Add`, this.Servico)
                    .then(response => {
                        if (response.status >= 200 && response.status < 300) {
                            this.$mensagemAvisoSucesso('Registro Incluído.');
                            this.Get();
                        }
                    })
                    .catch(() => {
                        this.$mensagemAviso('Erro ao incluir registro.');
                    });
            }
        },
        Put() {
            if (!this.Servico.lseNome) {
                this.$mensagemAviso('Nome Obrigatório.');
            } else if (this.Servico.lseQuantidade === null || this.Servico.lseQuantidade === undefined) {
                this.$mensagemAviso('Quantidade Obrigatória.');
            } else if (this.Servico.lseValor === null || this.Servico.lseValor === undefined) {
                this.$mensagemAviso('Valor Obrigatório.');
            } else if (!this.Servico.lsePeriodicidade) {
                this.$mensagemAviso('Periodicidade Obrigatória.');
            } else if (this.Servico.lseCodigoServicoGarantePay === null || this.Servico.lseCodigoServicoGarantePay === undefined) {
                this.$mensagemAviso('Código do Serviço GarantePay Obrigatório.');
            } else {
                axios.put(`/Telas/CadastroListaServicoExtra/Update`, this.Servico)
                    .then(response => {
                        if (response.status >= 200 && response.status < 300) {
                            this.$mensagemAvisoSucesso('Registro Alterado.');
                            this.Get();
                        }
                    })
                    .catch(() => {
                        this.$mensagemAviso('Erro ao alterar registro.');
                    });
            }
        },
        EditCancel() {
            this.EditView = false;
        },
        DeleteGrid(item) {
            this.$mensagemConfirma('Tem certeza que deseja excluir?')
                .then((result) => {
                    if (result.isConfirmed) {
                        const param1 = item.lseId;
                        axios.delete(`/Telas/CadastroListaServicoExtra/Delete/${param1}`)
                            .then(response => {
                                if (response.status === 200) {
                                    this.$mensagemAvisoSucesso('Registro Excluido.');
                                    this.Get();
                                }
                            });
                    }
                });
        },
        formatCurrency(value) {
            if (value === null || value === undefined || value === '') return '';
            return Number(value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        async Get() {
            this.EditView = false;
            await axios.get(`/Telas/CadastroListaServicoExtra/GetAll`)
                .then(response => {
                    this.Servicos = Array.isArray(response.data)
                        ? response.data
                        : Array.isArray(response.data?.data)
                            ? response.data.data
                            : [];
                })
                .catch(() => {
                    this.Servicos = [];
                });
        }
    },
    created() {
        this.Get();
    }
};
</script>

<style></style>
